/* src/app/shared-components/mb-field/mb-field.component.scss */
:host ::ng-deep {
  display: block;
}
:host ::ng-deep div {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0.5rem;
}
:host ::ng-deep div p {
  display: inline;
  margin: 1.25rem 0 0.5rem 0;
}
:host ::ng-deep div input,
:host ::ng-deep div select {
  min-width: 100px;
  height: calc(4rem + 2px);
  font-size: 1.6rem;
  border-radius: 0.5rem;
  border: 1px solid rgb(215, 225, 238);
  padding: 0.6rem 1.2rem;
  background-clip: padding-box;
  outline: 0;
  color: rgb(80, 94, 111);
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
:host ::ng-deep div input:focus,
:host ::ng-deep div select:focus {
  box-shadow: 0 0 0 0.25rem rgba(215, 225, 238, 0.5);
}
:host ::ng-deep div input::placeholder,
:host ::ng-deep div select::placeholder {
  color: rgba(80, 94, 111, 0.25);
}
:host ::ng-deep div input[disabled],
:host ::ng-deep div select[disabled] {
  background-color: rgba(215, 225, 238, 0.5);
}
:host ::ng-deep div input[disabled]:hover,
:host ::ng-deep div select[disabled]:hover {
  cursor: not-allowed;
}
:host ::ng-deep div input[disabled]::placeholder,
:host ::ng-deep div select[disabled]::placeholder {
  color: rgba(80, 94, 111, 0);
}
:host ::ng-deep div input[type=checkbox],
:host ::ng-deep div select[type=checkbox] {
  width: fit-content;
  min-width: 2rem;
  height: calc(2rem + 2px);
  margin: 1.25rem 2rem 0.75rem 1rem;
}
:host ::ng-deep div.preicon input,
:host ::ng-deep div.preicon select {
  padding-left: 4rem;
}
:host ::ng-deep div.preicon > i:first-of-type {
  position: absolute;
  bottom: 1.5rem;
  left: 1.5rem;
  color: rgba(80, 94, 111, 0.4);
}
:host ::ng-deep div.posticon input,
:host ::ng-deep div.posticon select {
  padding-left: 4rem;
}
:host ::ng-deep div.posticon > i:last-of-type {
  position: absolute;
  bottom: 1.5rem;
  right: 1.5rem;
  color: rgba(80, 94, 111, 0.4);
}
:host ::ng-deep div.pill input,
:host ::ng-deep div.pill select {
  border-radius: 5rem;
}
:host ::ng-deep div.fullwidth input,
:host ::ng-deep div.fullwidth select {
  width: 100%;
}
:host ::ng-deep div.inline {
  flex-direction: row;
  margin: 4rem 0.5rem 0.5rem 2.5rem;
}
/*# sourceMappingURL=mb-field.component.css.map */
